import React from 'react';
import { FormattedMessage } from 'react-intl';
// Import Shared Components
import { Label } from 'shared-components';
import PropTypes from 'prop-types';

const LabelWrapper = ({ labelFor, label, page, ...props }) => (
  <Label htmlFor={labelFor} {...props}>
    <FormattedMessage
      id={page ? `${page}-${labelFor}-label` : `${labelFor}-label`}
      description={`Label for ${label}`}
      defaultMessage={`${label}`}
    />
  </Label>
);

LabelWrapper.propTypes = {
  page: PropTypes.string,
  labelFor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default LabelWrapper;
